import React from "react";
import { Link } from "react-router-dom";

// Before/after repair gallery — uses existing gallery images as placeholders.
// Replace src paths with actual before/after photos when available.
const galleryItems = [
  {
    before: "/assets/images/gallery/01.jpg",
    after: "/assets/images/gallery/02.jpg",
    title: "iPhone 14 Pro Screen Replacement",
    description: "Shattered OLED replaced in 45 minutes. Customer watched in-store.",
    device: "iPhone",
  },
  {
    before: "/assets/images/gallery/03.jpg",
    after: "/assets/images/gallery/04.jpg",
    title: "Samsung Galaxy S22 Battery Swap",
    description: "Battery at 62% health. Replaced. Back to all-day battery life.",
    device: "Samsung",
  },
  {
    before: "/assets/images/gallery/01.jpg",
    after: "/assets/images/gallery/02.jpg",
    title: "iPad Air 5 Cracked Digitizer",
    description: "Shattered glass replaced. LCD underneath was intact — saved $200+.",
    device: "iPad",
  },
  {
    before: "/assets/images/gallery/03.jpg",
    after: "/assets/images/gallery/04.jpg",
    title: "MacBook Pro Liquid Damage Recovery",
    description: "Coffee spill. Ultrasonic cleaning + logic board repair. Full recovery.",
    device: "MacBook",
  },
];

const RepairGallery = () => {
  return (
    <section
      style={{
        padding: "60px 0",
        background: "#ffffff",
      }}
      aria-label="Before and after repair photos"
    >
      <div className="container">
        {/* Header */}
        <div className="text-center mb-40">
          <div
            style={{
              display: "inline-block",
              background: "rgba(245, 9, 99, 0.1)",
              color: "#F50963",
              padding: "5px 16px",
              borderRadius: "20px",
              fontSize: "0.8rem",
              fontWeight: 700,
              marginBottom: "15px",
              letterSpacing: "0.5px",
            }}
          >
            <i className="fas fa-camera mr-2" />
            REAL REPAIRS · REAL CUSTOMERS
          </div>
          <h2
            style={{
              fontSize: "2rem",
              fontWeight: 800,
              color: "#18305d",
              marginBottom: "12px",
            }}
          >
            Before & After: See the Work
          </h2>
          <p
            style={{
              fontSize: "1.05rem",
              color: "#666",
              maxWidth: "640px",
              margin: "0 auto",
              lineHeight: 1.6,
            }}
          >
            Every device you see here was repaired at our Willow Grove, PA store.
            Real photos, real customers, real same-day turnaround.
          </p>
        </div>

        {/* Gallery grid */}
        <div className="row">
          {galleryItems.map((item, idx) => (
            <div key={idx} className="col-lg-6 col-md-6 mb-30">
              <div
                style={{
                  background: "#f8f9fa",
                  borderRadius: "14px",
                  overflow: "hidden",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                  height: "100%",
                  transition: "transform 0.2s ease, box-shadow 0.2s ease",
                }}
              >
                {/* Before/After split image */}
                <div style={{ position: "relative", display: "flex", height: "220px" }}>
                  <div
                    style={{
                      flex: 1,
                      position: "relative",
                      overflow: "hidden",
                      borderRight: "2px solid #fff",
                    }}
                  >
                    <img
                      src={process.env.PUBLIC_URL + item.before}
                      alt={`${item.title} — before repair`}
                      loading="lazy"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                        filter: "saturate(0.85) contrast(0.95)",
                      }}
                    />
                    <div
                      style={{
                        position: "absolute",
                        top: "12px",
                        left: "12px",
                        background: "rgba(220, 53, 69, 0.95)",
                        color: "#fff",
                        padding: "4px 10px",
                        borderRadius: "4px",
                        fontSize: "0.72rem",
                        fontWeight: 700,
                        letterSpacing: "0.5px",
                      }}
                    >
                      BEFORE
                    </div>
                  </div>
                  <div
                    style={{
                      flex: 1,
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={process.env.PUBLIC_URL + item.after}
                      alt={`${item.title} — after repair`}
                      loading="lazy"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                      }}
                    />
                    <div
                      style={{
                        position: "absolute",
                        top: "12px",
                        right: "12px",
                        background: "rgba(40, 167, 69, 0.95)",
                        color: "#fff",
                        padding: "4px 10px",
                        borderRadius: "4px",
                        fontSize: "0.72rem",
                        fontWeight: 700,
                        letterSpacing: "0.5px",
                      }}
                    >
                      AFTER
                    </div>
                  </div>
                </div>

                {/* Caption */}
                <div style={{ padding: "20px" }}>
                  <div
                    style={{
                      display: "inline-block",
                      background: "#18305d",
                      color: "#ffaa19",
                      padding: "2px 10px",
                      borderRadius: "4px",
                      fontSize: "0.72rem",
                      fontWeight: 700,
                      marginBottom: "10px",
                      letterSpacing: "0.5px",
                    }}
                  >
                    {item.device}
                  </div>
                  <h3
                    style={{
                      fontSize: "1.1rem",
                      fontWeight: 700,
                      color: "#18305d",
                      marginBottom: "8px",
                    }}
                  >
                    {item.title}
                  </h3>
                  <p style={{ fontSize: "0.92rem", color: "#666", margin: 0, lineHeight: 1.5 }}>
                    {item.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-30">
          <Link
            to="/contact-us"
            className="btn btn-primary"
            style={{ padding: "14px 36px", fontSize: "1rem", fontWeight: 700 }}
          >
            <i className="fas fa-bolt mr-2" />
            Fix My Device Now
          </Link>
        </div>
      </div>
    </section>
  );
};

export default RepairGallery;
